// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list .theme--dark.v-list-item .v-list-item__title[data-v-031fa3e6]{line-height:3;min-width:11.25rem}", ""]);
// Exports
module.exports = exports;
